
import { css } from "@emotion/core"

export default css`
  body {
    font-family: "IBM Plex Sans", system-ui, sans-serif;
  }
  .rsm-zoomable-group > g {
    transition: all 500ms cubic-bezier(0.77, 0, 0.175, 1);
  }
`
